import React, { useEffect, useState, useRef } from 'react';
import { Quote, ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  const [i, setI] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    timer.current = setInterval(() => setI((v) => (v + 1) % testimonials.length), 6000);
    return () => clearInterval(timer.current);
  }, []);

  const go = (dir) => {
    setI((v) => (v + dir + testimonials.length) % testimonials.length);
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = setInterval(() => setI((v) => (v + 1) % testimonials.length), 6000);
    }
  };

  const t = testimonials[i];

  return (
    <section id="testimonials" className="py-14 sm:py-20 lg:py-24 bg-[#2A1810]">
      <div className="max-w-6xl mx-auto px-4 sm:px-5 lg:px-8 text-center">
        <p className="text-[#F4C430] text-[10px] sm:text-xs tracking-[0.3em] sm:tracking-[0.35em] uppercase">Loved by our community</p>
        <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5EDE0] leading-tight">
          Stories from real minds
        </h2>

        <div className="mt-8 sm:mt-12 relative rounded-3xl bg-[#3D2817] border border-[#4a3221] p-6 sm:p-8 lg:p-14">
          <Quote className="absolute -top-4 sm:-top-5 left-6 sm:left-8 text-[#F4C430]" size={32} />
          <div key={t.name} className="fade-up">
            <div className="flex justify-center gap-1 text-[#F4C430]">
              {[...Array(5)].map((_, k) => (<Star key={k} size={14} className="fill-[#F4C430]" />))}
            </div>
            <p className="mt-4 sm:mt-6 font-serif italic text-lg sm:text-xl lg:text-2xl text-[#F5EDE0] leading-relaxed max-w-3xl mx-auto">
              &ldquo;{t.quote}&rdquo;
            </p>
            <div className="mt-6 sm:mt-8 flex items-center justify-center gap-4">
              <div className="h-11 w-11 sm:h-12 sm:w-12 rounded-full grid place-items-center bg-[#F4C430] text-[#2A1810] font-serif text-lg sm:text-xl font-bold">
                {t.initial}
              </div>
              <div className="text-left">
                <div className="text-[#F5EDE0] font-semibold text-sm sm:text-base">{t.name}</div>
                <div className="text-[#B8A990] text-xs sm:text-sm">{t.role}</div>
              </div>
            </div>
          </div>

          <div className="mt-8 sm:mt-10 flex items-center justify-center gap-3 sm:gap-4">
            <button
              onClick={() => go(-1)}
              className="h-9 w-9 sm:h-10 sm:w-10 rounded-full grid place-items-center border border-[#5a3d24] text-[#F5EDE0] hover:border-[#F4C430] hover:text-[#F4C430]"
              aria-label="prev"
            >
              <ChevronLeft size={18} />
            </button>
            <div className="flex gap-1.5">
              {testimonials.map((_, k) => (
                <button
                  key={k}
                  onClick={() => setI(k)}
                  className={`h-1.5 rounded-full transition-all ${
                    i === k ? 'w-6 bg-[#F4C430]' : 'w-1.5 bg-[#5a3d24]'
                  }`}
                  aria-label={`slide ${k + 1}`}
                />
              ))}
            </div>
            <button
              onClick={() => go(1)}
              className="h-9 w-9 sm:h-10 sm:w-10 rounded-full grid place-items-center border border-[#5a3d24] text-[#F5EDE0] hover:border-[#F4C430] hover:text-[#F4C430]"
              aria-label="next"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
